export default __webpack_public_path__ + "static/media/gears.98f9b850.svg";